/* istanbul ignore file */
import { useRoute, useRouter } from 'vue-router';
import { ref, watch } from 'vue';

let route;
let router;
/**
 * Composable for working with routes.
 *
 * @description
 * This composable is used to manipulate with page routes.
 *
 */

export default function useRouting() {
  route = useRoute();
  router = useRouter();

  const searchTerms = ref(
    route.query?.keyword || route?.params?.featuredName || 'dress',
  );

  function routerPush(pathName, query = {}) {
    router.push({ path: pathName, query });
  }

  function isCurrentRouteFeatured() {
    return route.fullPath.includes('featured');
  }

  function onRouteChange(callback) {
    watch(
      () => route.query,
      async () => {
        callback(route);
      },
    );
  }

  function getQueryParams() {
    return route.query;
  }

  return {
    route,
    router,
    searchTerms,
    isCurrentRouteFeatured,
    routerPush,
    onRouteChange,
    getQueryParams,
  };
}
